module.exports = __webpack_public_path__ + "static/advancedblockchain-9b5f54cc958c2d8b9847461e6e15e99c.svg";